import { Button } from '@creditornot/cb-button';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import WoltModal from 'common/components/WoltModal';
import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography } from 'common/typography';

import Step1Image from './images/ios-instruction-step-1.svg';
import Step2Image from './images/ios-instruction-step-2.png';

export type IosInstructionsModalProps = {
  isOpen?: boolean;
  onClose: () => void;
};

const StyledWrapper = styled(WoltModal)`
  width: 500px;
  padding: 32px 16px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    margin: 0 16px;
  }
`;

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;

  img {
    align-self: center;
    width: 100%;
    max-width: 400px;
    background-color: white;
  }
`;

export const IosInstallGuideModal = ({ isOpen, onClose }: IosInstructionsModalProps) => {
  const intl = useIntl();
  return (
    <StyledWrapper isOpen={!!isOpen} onRequestClose={onClose}>
      <StyledSection>
        <Typography.Heading4>
          <FormattedMessage id="pwa.instructions.step-number" values={{ stepNumber: 1 }} />
        </Typography.Heading4>
        <Typography.Body3>
          <FormattedMessage id="pwa.instructions.step-1-description" />
        </Typography.Body3>
        <img
          src={Step1Image}
          alt={intl.formatMessage(
            { id: 'pwa.instructions.step-number' },
            {
              stepNumber: (1).toLocaleString(),
            },
          )}
        />
      </StyledSection>

      <StyledSection>
        <Typography.Heading4>
          <FormattedMessage id="pwa.instructions.step-number" values={{ stepNumber: 2 }} />
        </Typography.Heading4>
        <Typography.Body3>
          <FormattedMessage id="pwa.instructions.step-2-description" />
        </Typography.Body3>
        <img
          src={Step2Image}
          alt={intl.formatMessage(
            { id: 'pwa.instructions.step-number' },
            {
              stepNumber: (2).toLocaleString(),
            },
          )}
        />
      </StyledSection>

      <StyledSection>
        <Typography.Heading4>
          <FormattedMessage id="pwa.instructions.step-number" values={{ stepNumber: 3 }} />
        </Typography.Heading4>
        <Typography.Body3>
          <FormattedMessage id="pwa.instructions.step-3-description" />
        </Typography.Body3>
      </StyledSection>

      <Button size="small" variant="secondary" onClick={onClose} stretch>
        <FormattedMessage id="state.close" />
      </Button>
    </StyledWrapper>
  );
};
